module.exports = __webpack_public_path__ + "static/media/intro-hero-blurbs--mobile.87fc2cf9.png";